<template>
  <div v-loading="isLoading" :class="{'cs-courseEnrollmentList-container': true, 'cs-courseEnrollmentList-container-vertical': isVerticalAlign}">
    <div v-for="item in courseList" :key="item.courseData.courseId"
      :class="{'cs-courseEnrollmentList-container-item': true, 'cs-courseEnrollmentList-container-item-vertical': isVerticalAlign}">
      <courseEnrollmentDetail ref="courseEnrollmentDetailList" :studentId="studentId" :vipCourseAliasList="vipCourseAliasList"
        :isVerticalAlign="isVerticalAlign" :totalBonusPoint="bonusPoint" :bonusPointDisabled="bonusPointDisabled" :isCalculating="isCalculating"
        :isReadonly="isReadonly" :availableBonusPoint="availableBonusPoint" :priceSettings="priceSettings" :allContractList="allContractList"
        :wComment="dataIn.comment" :dataIn="item" @calculate="onCourseCalculate" @contractChange="onContractChange" @contractAgreed="onContractAgreed">
      </courseEnrollmentDetail>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-courseEnrollmentList-container {
  &.cs-courseEnrollmentList-container-vertical {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .cs-courseEnrollmentList-container-item-vertical {
    flex-grow: 1;
    flex-basis: 25%;

    border-left: 1px solid #ced3d9;

    &:nth-of-type(2) {
      border-left: none;
    }
  }
}
</style>

<script>
import courseEnrollmentDetail from "./courseEnrollmentDetail";
import { getWeekList } from "../../../service/termManage.service";
import { getVipCoursePrices } from "@/service/globalPriceSetting.service";
import {
  getSupplementVideoTypeList,
  getWeChatGroupTypeList,
  getAllCourseCategoryList,
} from "../../../service/common.service";
import { getAllContractList } from "@/service/contract.service";

export default {
  props: {
    courseType: Number,
    bonusPoint: Number,
    studentId: Number,
    priceSettings: Object,
    vipCourseAliasList: Array,
    isReadonly: Boolean,
    isCalculating: Boolean,
    bonusPointDisabled: Boolean,
    isVerticalAlign: Boolean,
    dataIn: {
      termId: Number,
      comment: String,
      enrollmentAvailableCount: Number,
      trainingEnrollmentAvailableCount: Number,
      courseList: Array,
      studentAdvanceEnrollmentList: Array,
      studentAdvanceEnrollmentAdditional: String,
    },
  },
  data() {
    return {
      weekList: [],
      supplementVideoTypeList: [],
      allContractList: {},
      weChatGroupTypeList: [],
      isLoading: true,
      courseList: [],
      allCourseCategoryList: {},
      lastTermId: -1,
      contractNewStudent: {},
      contractType: 2,
      availableBonusPoint: 0,
      vipCoursePrices: [],
    };
  },
  components: {
    courseEnrollmentDetail,
  },
  created() {
    this.loadWeekList();
    this.loadVipCoursePrices();
    getAllContractList().then((result) => {
      if (!!result && result.success) {
        this.allContractList = result.data;
        this.init();
      }
    });

    getSupplementVideoTypeList().then((result) => {
      if (!!result && result.success) {
        this.supplementVideoTypeList = result.data;
        this.init();
      }
    });

    getWeChatGroupTypeList().then((result) => {
      if (!!result && result.success) {
        this.weChatGroupTypeList = result.data;
        this.init();
      }
    });

    getAllCourseCategoryList(true).then((result) => {
      if (!!result && result.success) {
        this.allCourseCategoryList = result.data;
        this.init();
      }
    });
  },
  methods: {
    init() {
      if (
        this.vipCoursePrices &&
        this.vipCoursePrices.length &&
        ((!!this.weekList && this.weekList.length > 0) ||
          this.courseType == 2 ||
          this.courseType == 4) &&
        !!this.supplementVideoTypeList &&
        this.supplementVideoTypeList.length > 0 &&
        !!this.weChatGroupTypeList &&
        this.weChatGroupTypeList.length > 0 &&
        !!this.allContractList &&
        Object.keys(this.allContractList).length > 0 &&
        !!this.allCourseCategoryList &&
        Object.keys(this.allCourseCategoryList).length > 0 &&
        !!this.dataIn &&
        this.dataIn.courseList
      ) {
        this.isLoading = false;
        let list = [];
        let isCalculate = false;
        let categoryList = this.allCourseCategoryList[this.courseType];
        this.contractType = this.GLOBAL.contractType.getValueByCourseType(
          this.courseType
        );

        let contractList = this.getContractList(this.contractType);
        if (!!contractList) {
          let newContract = contractList.filter((i) => i.Name == "New");
          if (newContract.length) {
            this.contractNewStudent = newContract[0];
          }
        }

        let startWeekDefault = 1;
        let currentWeek = this.weekList.filter((i) => i.IsCurrent);
        if (currentWeek.length > 0) {
          startWeekDefault = currentWeek[0].Week;
        }
        this.dataIn.courseList.forEach((element) => {
          if (!element.modelData.categoryId && categoryList.length > 0) {
            let categoryId = categoryList[0].Id;
            if (this.courseType == 1) {
              categoryId = 11; //默认选择线上课
            }
            this.$set(element.modelData, "categoryId", categoryId);
          }

          if (element.isYearCourse) {
            if (!element.modelData.yearCourseType) {
              let keys = Object.keys(element.yearCourseTypeWithWeek);
              if (keys.length > 0) {
                this.$set(
                  element.modelData,
                  "yearCourseType",
                  parseInt(keys[0])
                );
              }
            }

            if (!element.modelData.startWeek) {
              let startWeek = 1;
              let weekList =
                element.yearCourseTypeWithWeek[
                  element.modelData.yearCourseType
                ];
              if (!!weekList) {
                let currentWeekObj = weekList.find((i) => i.IsCurrent);
                if (!!currentWeekObj) {
                  startWeek = currentWeekObj.Week;
                } else {
                  startWeek = weekList[0].Week;
                }
                this.$set(element.modelData, "startWeek", startWeek);
              }
            }
          } else {
            if (!element.modelData.startWeek) {
              this.$set(element.modelData, "startWeek", startWeekDefault);
            }
          }

          let item = {
            vipCoursePrices: this.vipCoursePrices,
            weekList: this.weekList,
            supplementVideoTypeList: this.supplementVideoTypeList,
            contractList: contractList,
            weChatGroupTypeList: this.weChatGroupTypeList,
            selectedDiscountList: element.selectedDiscountList,
            courseCategoryList: categoryList,
            hasAdvanceEnrollmentPrice: true,
            hasInternalPrice: true,
            hasOriginalPrice: true,
            modelData: element.modelData,
            priceData: element.priceData,
            courseData: {
              courseId: element.courseId,
              courseName: element.courseName,
              courseType: element.courseType,
              courseTypeText: element.courseTypeText,
              universityGroup: element.universityGroup,
              universityGroupText: element.universityGroupText,
              termId: element.termId,
              termText: element.termText,
              isRefund: element.isRefund,
              changeFromCourseName: element.changeFromCourseName,
              categoryId: element.categoryId,
              categoryText: element.categoryText,
              campusId: element.campusId,
              campusText: element.campusText,
              isHourPrice: element.isHourPrice,
              isYearCourse: element.isYearCourse,
              yearCourseTypeWithWeek: element.yearCourseTypeWithWeek,
              studentAdvanceEnrollmentList:
                this.dataIn.studentAdvanceEnrollmentList,
              studentAdvanceEnrollmentAdditional:
                this.dataIn.studentAdvanceEnrollmentAdditional,
              selectedStudentAdvanceEnrollmentId:
                element.selectedStudentAdvanceEnrollmentId,
              defaultContractId: element.defaultContractId,
            },
          };
          list.push(item);
          if (!element.priceData || !element.priceData.price) {
            isCalculate = true;
          }
        });
        this.checkAdvanceEnrollmentAndInternalPrice(list);
        this.calculateAvailableBonusPoint();
        this.courseList = list;
        this.triggerCalculate();
      } else {
        this.courseList = [];
      }
    },
    loadWeekList() {
      if (this.dataIn.termId != this.lastTermId) {
        this.lastTermId = this.dataIn.termId;
        this.weekList = [];
        getWeekList(this.dataIn.termId).then((result) => {
          if (!!result && result.success) {
            this.weekList = result.data;
            this.init();
          }
        });
      }
    },
    loadVipCoursePrices() {
      getVipCoursePrices().then((result) => {
        if (!!result && result.success) {
          this.vipCoursePrices = result.data;
          this.init();
        }
      });
    },
    onContractChange(id) {
      if (!!this.contractNewStudent && !!this.contractNewStudent.Id) {
        let hasNewStudentContract =
          this.courseList.filter(
            (i) => i.modelData.contractId == this.contractNewStudent.Id
          ).length > 0;

        if (id == this.contractNewStudent.Id) {
          this.courseList.forEach((element) => {
            element.modelData.contractId = this.contractNewStudent.Id;
          });
        } else {
          if (hasNewStudentContract) {
            this.courseList.forEach((element) => {
              if (element.modelData.contractId == this.contractNewStudent.Id) {
                element.modelData.contractId = 0;
              }
            });
          }
        }
      }
    },
    onContractAgreed(workflowCourseId) {
      this.$emit("contractAgreed", workflowCourseId);
    },
    checkAdvanceEnrollmentAndInternalPrice(courseList) {
      let hasInternal =
        courseList.filter((i) => i.modelData.isInternalPrice).length > 0;
      let enrollmentCountUsed = courseList.filter(
        (i) => i.modelData.isAdvanceEnrollmentPrice
      ).length;

      courseList.forEach((element) => {
        let availableCount = this.dataIn.enrollmentAvailableCount;
        if (this.courseType == 3) {
          availableCount = this.dataIn.trainingEnrollmentAvailableCount;
        } else if (this.courseType == 2 || this.courseType == 4) {
          availableCount = 0;
        }
        if (availableCount > 0) {
          if (enrollmentCountUsed >= availableCount) {
            if (element.modelData.isAdvanceEnrollmentPrice) {
              element.hasAdvanceEnrollmentPrice = true;
            } else {
              element.hasAdvanceEnrollmentPrice = false;
            }
          } else {
            element.hasAdvanceEnrollmentPrice = true;
          }
        } else {
          element.hasAdvanceEnrollmentPrice = false;
        }
      });
    },
    getContractList(contractType) {
      let list = [];
      if (
        !!this.allContractList &&
        Object.keys(this.allContractList).length > 0
      ) {
        list = this.allContractList[contractType].filter((item) => item.Enable);
      }
      return list;
    },
    onCourseCalculate() {
      this.checkAdvanceEnrollmentAndInternalPrice(this.courseList);
      this.calculateAvailableBonusPoint();
      this.triggerCalculate();
    },
    calculateAvailableBonusPoint() {
      let value = this.bonusPoint;

      let allBonusPointCost = 0;
      this.courseList.forEach(function (item, index) {
        allBonusPointCost += item.priceData.bonusPointCost;
      });
      value -= allBonusPointCost;
      if (value < 0) value = 0;

      this.availableBonusPoint = value;
    },
    triggerCalculate() {
      this.$emit("calculate");
    },
    selectAdvanceEnrollmentForDiscount(isSelected) {
      for (let i = 0; i < this.courseList.length; i++) {
        if (i < this.dataIn.studentAdvanceEnrollmentList.length) {
          let id = this.dataIn.studentAdvanceEnrollmentList[i].Id;
          this.$refs.courseEnrollmentDetailList[
            i
          ].selectAdvanceEnrollmentForDiscount(isSelected, id);
        } else {
          this.$refs.courseEnrollmentDetailList[
            i
          ].selectAdvanceEnrollmentForDiscount(isSelected, 0);
        }
      }
    },
  },
  watch: {
    // dataIn: function() {
    //   this.loadWeekList();
    //   this.init();
    // },
    "dataIn.termId": function () {
      this.loadWeekList();
    },
    "dataIn.courseList": function () {
      this.init();
    },
    "dataIn.studentAdvanceEnrollmentAdditional": function () {
      this.courseList.forEach(
        (i) =>
          (i.courseData.studentAdvanceEnrollmentAdditional =
            this.dataIn.studentAdvanceEnrollmentAdditional)
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/courseEnrollmentFee/courseEnrollmentList.vue